import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import compose from 'lodash/fp/compose';

import { connect } from 'react-redux';
import * as authActions from 'actions/authentication';
import { BaseHOC, withBaseHOCProps } from '../common/BaseHOC';
import { withRouterHooks } from '../withRouterHooks';
import { Navigate } from 'react-router-dom';

export const withAuthentication = (WrapperComponent) => {
  class Authentication extends React.Component {
    render() {
      if (!localStorage.token || !localStorage.user) {
        return <Navigate to="/login" replace />;
      }
      return <WrapperComponent {...this.props} />;
    }
  }
  hoistNonReactStatics(Authentication, WrapperComponent);
  return compose(withRouterHooks)(Authentication);
};

export const withNoAuthentication = (WrapperComponent) => {
  class NoAuthentication extends React.Component {
    render() {
      if (localStorage.token && localStorage.user) {
        return <Navigate to="/dashboard" replace />;
      }
      return <WrapperComponent {...this.props} />;
    }
  }
  hoistNonReactStatics(NoAuthentication, WrapperComponent);
  return compose(withRouterHooks)(NoAuthentication);
};

export const withAdminAuthentication = (WrapperComponent) => {
  class Authentication extends React.Component {
    render() {
      if (!localStorage.token || !localStorage.user) {
        return <Navigate to="/admin" replace />;
      }
      return <WrapperComponent {...this.props} />;
    }
  }
  hoistNonReactStatics(Authentication, WrapperComponent);
  return compose(withRouterHooks)(Authentication);
};

export const withNoAdminAuthentication = (WrapperComponent) => {
  class NoAuthentication extends React.Component {
    render() {
      if (localStorage.token && localStorage.user) {
        return <Navigate to="/admin/dashboard" replace />;
      }
      return <WrapperComponent {...this.props} />;
    }
  }
  hoistNonReactStatics(NoAuthentication, WrapperComponent);
  return compose(withRouterHooks)(NoAuthentication);
};

let loaded = false;

export const withAuth = (WrapperComponent) => {
  class Auth extends BaseHOC {
    async componentDidMount() {
      const { getUser } = this.props;
      if (!loaded) {
        loaded = true;
        await getUser();
      }
    }

    render() {
      return <WrapperComponent {...this.props} />;
    }
  }
  const mapStateToProps = ({ authentication, user }) => ({ authentication, user });
  const WithAuth = connect(mapStateToProps, {
    ...authActions,
  })(Auth);
  hoistNonReactStatics(WithAuth, WrapperComponent);
  return compose(withBaseHOCProps)(WithAuth);
};
